import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'animate.css';
import 'element-plus/dist/index.css'
import i18n from "./components/lang";
import ZText from '@namchee/vue-ztext';
import *as echartsGL from 'echarts-gl'

createApp(App).use(router).use(ElementPlus).use(echartsGL).use(ZText).use(i18n).mount('#app')
